import React, { useState, useRef, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Link, useLocation } from "react-router-dom";
import { Link, NavLink, useLocation } from "react-router-dom";
// import Logo from "../../PicesForPages/logo_orange_the_mortgagist.png";
import Logo from "../../PicesForPages/logo_orange_the_mortgagist.png";
import menuButton from "../../PicesForPages/menu.png";

function Header() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };

  const location = useLocation();

  const applyNowUrls = {
    "apeksha-sista":
      "https://themortgageist.my1003app.com/2692605/register?time=1772393517544",
    "kumar-sista":
      "https://themortgageist.my1003app.com/2369551/register?time=1772393677677",
    "vai-sista":
      "https://themortgageist.my1003app.com/2719500/register?time=1772393677677",
    "vamsi-tummala":
      "https://themortgageist.my1003app.com/2587554/register?time=1772393677677",
    "kousalya-tummala":
      "https://themortgageist.my1003app.com/2587557/register?time=1772393677677",
    "bhanu-chennubhotla":
      "https://themortgageist.my1003app.com/2497400/register?time=1772393677677",
    "maharshi-patel":
      "https://themortgageist.my1003app.com/2781812/register?time=1772393677677",
    "kiran-g":
      "https://themortgageist.my1003app.com/2525597/register?time=1772393677677",
    "raghuram-mylavarapu":
      "https://themortgageist.my1003app.com/2620091/register?time=1772393677677",
    "sanjeeva-pidugu":
      "https://themortgageist.my1003app.com/2776226/register?time=1772393677677",
  };

  const defaultApplyUrl =
    "https://themortgageist.my1003app.com/2692605/register/";

  let applyNowUrl = defaultApplyUrl;

  if (location.pathname.startsWith("/our-family/")) {
    const id = location.pathname.split("/our-family/")[1];
    if (applyNowUrls[id]) {
      applyNowUrl = applyNowUrls[id];
    }
  }

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div className="headerParent">
      <div className="HeaderTopDiv ">
        <div className="headerBox headerBoxTop">
          <span className="HeaderTopDivContent">
            <a
              href="https://maps.app.goo.gl/G5PhAHozSeMPGfhaA"
              target="_blank"
              rel="noreferrer"
              className="HeaderTopDivContentIcon HeaderTopDivContentIcon01"
            >
              <i className="ri-map-pin-line"></i>
              <span>134 John Robert Thomas Dr, 2nd Floor, Exton, PA 19341</span>
            </a>
            <a
              href="mailto: Contact@TheMortgageist.com"
              className="aTag_Mail HeaderTopDivContentIcon HeaderTopDivContentIcon02"
            >
              <i className="ri-mail-send-fill"></i>
              <span>Contact@TheMortgageist.com</span>
            </a>
            <a
              href="tel:+1-610-618-0618"
              className="aTag_Tel HeaderTopDivContentIcon HeaderTopDivContentIcon03"
            >
              <i className="ri-phone-fill"></i>
              <span>(610) 618-0618</span>
            </a>
          </span>
          <span className="HeaderTopDivContent HeaderTopDivContentSM">
            <a
              href="https://www.facebook.com/TheMortgageist/"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-facebook-box-fill"></i>
            </a>

            <a
              href="http://www.instagram.com/themortgageist"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-instagram-fill"></i>
            </a>

            <a
              href="http://www.linkedin.com/company/themortgageist"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-linkedin-box-fill"></i>
            </a>
            <a
              href="http://www.tiktok.com/@themortgageist"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-tiktok-fill"></i>
            </a>
            <a
              href="http://www.youtube.com/@TheMortgageist"
              className="HeaderTopDivContentIcon"
              target="_blank"
              rel="noreferrer"
            >
              <i className="ri-youtube-fill"></i>
            </a>
          </span>
        </div>
      </div>

      <div className="headerBox">
        <Link to="/" onClick={scrollToTop} className="headerLogoDiv">
          <img
            fetchPriority="high"
            loading="eager"
            src={Logo}
            alt="Logo"
            className="headerLogo"
          />
          {/* <span className="headerLogoNMLS">NMLS #: 2710734</span> */}
        </Link>
        <div className="headerMenu">
          <ul className="headerMenuUI">
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/todays-rates"
                onClick={scrollToTop}
              >
                Today’s Rates
              </NavLink>
            </li>
          </ul>
          <ul className="headerMenuUI">
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/purchase"
                onClick={scrollToTop}
              >
                Purchase
              </NavLink>
            </li>
          </ul>
          <ul className="headerMenuUI">
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/refinancing"
                onClick={scrollToTop}
              >
                Refinance
              </NavLink>
            </li>
          </ul>
          <ul className="headerMenuUI">
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/what-will-my-monthly-payment-be-calculator"
                onClick={scrollToTop}
              >
                Calculators
              </NavLink>
            </li>
          </ul>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">Loan Options &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="/fha"
                  onClick={scrollToTop}
                >
                  FHA Home Loan
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="/va-loans"
                  onClick={scrollToTop}
                >
                  VA Home Loan
                </NavLink>
              </li>

              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="/conventional-loans"
                  onClick={scrollToTop}
                >
                  Conventional Loans
                </NavLink>
              </li>

              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="/loans-for-self-employed"
                  onClick={scrollToTop}
                >
                  Loans For Self Employed
                </NavLink>
              </li>

              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="/loan-for-investors"
                  onClick={scrollToTop}
                >
                  Loan for Investors
                </NavLink>
              </li>

              {/* <li>
                <Link to="/dscr-loans" onClick={scrollToTop}>
                  DSCR Loans
                </Link>
              </li>
              <li>
                <Link to="/adjustable-rate-mortgage" onClick={scrollToTop}>
                  ARM
                </Link>
              </li>
              <li>
                <Link
                  to="/understanding-escrows-in-the-mortgage-industry"
                  onClick={scrollToTop}
                >
                  Understanding Escrows
                </Link>
              </li> */}

              {/* <li>
                <Link to="/what-will-my-monthly-payment-be-calculator">
                  VA Purchase
                </Link>
              </li>

              <li>
                <Link to="/refinance-analysis-calculator">VA Refinance</Link>
              </li>
              <li>
                <Link to="/buy-down" onClick={scrollToTop}>
                  Buy-Down
                </Link>
              </li>
              <li>
                <Link to="/debt-consolidation-calculator" onClick={scrollToTop}>
                  DSCR
                </Link>
              </li>*/}
            </span>
          </ul>
          <ul className="headerMenuUI">
            <span className="headerMenuUI_Header">About Us &#x025BF;</span>
            <span className="headerMenuUI_LI">
              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="/our-family"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Our Family
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="/about-us"
                  onClick={scrollToTop}
                >
                  Why The Mortgageist
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="join-our-family"
                  onClick={scrollToTop}
                >
                  Join Our Family
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "active" : "")}
                  to="/privacy-policy"
                  onClick={scrollToTop}
                >
                  Privacy Policy
                </NavLink>
              </li>
              {/* <li>
                <Link to="/communication-policy" onClick={scrollToTop}>
                  Communication Policy
                </Link>
              </li> */}
              <li>
                <Link
                  to={{ pathname: "/", hash: "#client_reviews" }}
                  // onClick={scrollToTop}
                >
                  Google Reviews
                </Link>
              </li>

              {/* <li>
                <Link to="/" onClick={scrollToTop}>
                  Home1
                </Link>
              </li>
              <li>
                <Link to="/2" onClick={scrollToTop}>
                  Home2
                </Link>
              </li> */}
            </span>
          </ul>
          <ul className="headerMenuUI">
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to="/learn"
                onClick={scrollToTop}
              >
                Learn
              </NavLink>
            </li>
          </ul>
          <Link
            to={applyNowUrl}
            target="_blank"
            rel="noreferrer"
            className="headerMenuButtonLink headerMenuButton"
          >
            Apply Now
          </Link>
        </div>
        <div className="headerMenuMobileView">
          {!menuOpen ? (
            <img
              fetchPriority="high"
              loading="eager"
              src={menuButton}
              alt="Menu Button"
              id="menubtn"
              onClick={toggleMenu}
            />
          ) : (
            <span id="closebtn" onClick={toggleMenu}>
              X
            </span>
          )}
          {menuOpen && (
            <div
              className="headerMenuMobileView headerMenuMobileViewlist"
              ref={menuRef}
            >
              <ul className="headerMenuUI">
                <li>
                  <NavLink
                    className={({ isActive }) => (isActive ? "active" : "")}
                    to="/todays-rates"
                    onClick={() => {
                      scrollToTop();
                      toggleMenu();
                    }}
                  >
                    Today’s Rates
                  </NavLink>
                </li>
              </ul>
              <ul className="headerMenuUI">
                <li>
                  <NavLink
                    className={({ isActive }) => (isActive ? "active" : "")}
                    to="/purchase"
                    onClick={() => {
                      scrollToTop();
                      toggleMenu();
                    }}
                  >
                    Purchase
                  </NavLink>
                </li>
              </ul>
              <ul className="headerMenuUI">
                <li>
                  <NavLink
                    className={({ isActive }) => (isActive ? "active" : "")}
                    to="/refinancing"
                    onClick={() => {
                      scrollToTop();
                      toggleMenu();
                    }}
                  >
                    Refinance
                  </NavLink>
                </li>
              </ul>
              <ul className="headerMenuUI">
                <li>
                  <NavLink
                    className={({ isActive }) => (isActive ? "active" : "")}
                    to="/what-will-my-monthly-payment-be-calculator"
                    onClick={() => {
                      scrollToTop();
                      toggleMenu();
                    }}
                  >
                    Calculators
                  </NavLink>
                </li>
              </ul>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">
                  Loan Options &#x025BF;
                </span>
                <span className="headerMenuUI_LI">
                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="/fha"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      FHA Home Loan
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="/va-loans"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      VA Home Loan
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="/conventional-loans"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Conventional Loans
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="/loans-for-self-employed"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Loans For Self Employed
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="/loan-for-investors"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Loan for Investors
                    </NavLink>
                  </li>

                  {/* <li>
                    <Link
                      to="/dscr-loans"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      DSCR Loans
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/adjustable-rate-mortgage"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      ARM
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/understanding-escrows-in-the-mortgage-industry"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Understanding Escrows
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link to="/what-will-my-monthly-payment-be-calculator">
                      VA Purchase
                    </Link>
                  </li>

                  <li>
                    <Link to="/refinance-analysis-calculator">
                      VA Refinance
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/buy-down"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Buy-Down
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/debt-consolidation-calculator"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      DSCR
                    </Link>
                  </li>   */}
                </span>
              </ul>
              <ul className="headerMenuUI">
                <span className="headerMenuUI_Header">About Us &#x025BF;</span>
                <span className="headerMenuUI_LI">
                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="/our-family"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Our Family
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="/about-us"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Why The Mortgageist
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="join-our-family"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Join Our Family
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to="/privacy-policy"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Privacy Policy
                    </NavLink>
                  </li>
                  {/* <li>
                    <Link
                      to="/communication-policy"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Communication Policy
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to={{ pathname: "/", hash: "#client-reviews" }}
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Google Reviews
                    </Link>
                  </li>

                  {/* <li>
                    <Link
                      to="/"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Home1
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/2"
                      onClick={() => {
                        scrollToTop();
                        toggleMenu();
                      }}
                    >
                      Home2
                    </Link>
                  </li> */}
                </span>
              </ul>
              <ul className="headerMenuUI">
                <li>
                  <NavLink
                    className={({ isActive }) => (isActive ? "active" : "")}
                    to="/learn"
                    onClick={() => {
                      scrollToTop();
                      toggleMenu();
                    }}
                  >
                    Learn
                  </NavLink>
                </li>
              </ul>
              <Link
                to={applyNowUrl}
                target="_blank"
                rel="noreferrer"
                className="headerMenuButtonLink headerMenuButton"
                onClick={toggleMenu}
              >
                Apply Now
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header;
